import React, { useEffect, useState, useMemo } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useAuth } from "../../AuthContext";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputMask } from "primereact/inputmask";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

import "primeicons/primeicons.css";

import {
  FaUserMd,
  FaCalendar,
  FaTooth,
  FaCalendarCheck,
  FaExchangeAlt,
  FaSearch,
  FaListAlt,
  FaDollarSign,
  FaClipboardList,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaMapPin,
  FaCity,
  FaGlobeAmericas,
  FaMailBulk,
  FaIdCard,
  FaCalendarAlt,
  FaClock,
  FaCheckCircle,
  FaBuilding,
  FaList,
  FaUserAlt,
  FaUserGraduate,
} from "react-icons/fa";

const Profissionais = () => {
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [profissionais, setProfissionais] = useState([]);
  const [visualizacaoResumida, setVisualizacaoResumida] = useState(false);
  const [visibleNovoProfissional, setVisibleNovoProfissional] = useState(false);
  const [visibleEditarProfissional, setVisibleEditarProfissional] =
    useState(false);

  // Novos dialogs para Datas, Horários e Serviços
  const [visibleDatasProfissional, setVisibleDatasProfissional] =
    useState(false);
  const [visibleHorariosProfissional, setVisibleHorariosProfissional] =
    useState(false);
  const [visibleServicosProfissional, setVisibleServicosProfissional] =
    useState(false);

  //Cadastro
  const [profissionalEditandoId, setProfissionalEditandoId] = useState(null);
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [cpf, setCpf] = useState("");
  const [rg, setRg] = useState("");
  const [dtNascimento, setDtNascimento] = useState("");
  const [cro, setCro] = useState("");
  const [especialidade, setEspecialidade] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [cep, setCep] = useState("");
  const [ativo, setAtivo] = useState(true);
  const [empresasSelecionadas, setEmpresasSelecionadas] = useState([]);
  const [empresasOptions, setEmpresasOptions] = useState([]);

  // Estados para Datas
  const [datasProfissional, setDatasProfissional] = useState([]);
  const [modoCalendario, setModoCalendario] = useState("adicionar");
  const [datasSelecionadas, setDatasSelecionadas] = useState([]);
  const [mesCalendario, setMesCalendario] = useState(new Date());

  // Estados para Horários
  const [horariosProfissional, setHorariosProfissional] = useState([]);
  const [diaSemanaEditando, setDiaSemanaEditando] = useState(1);
  const [horariosOriginal, setHorariosOriginal] = useState({});
  const [horariosEditando, setHorariosEditando] = useState({
    0: [], // Domingo
    1: [], // Segunda
    2: [], // Terça
    3: [], // Quarta
    4: [], // Quinta
    5: [], // Sexta
    6: [], // Sábado
  });

  // Estados para Serviços
  const [servicosDisponiveis, setServicosDisponiveis] = useState([]);
  const [servicosAssociados, setServicosAssociados] = useState([]);
  const [servicosSelecionados, setServicosSelecionados] = useState([]);
  const [servicosParaAdicionar, setServicosParaAdicionar] = useState([]);
  const [servicosParaRemover, setServicosParaRemover] = useState([]);

  // Estados para os dialogs de confirmação
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  //Filtro
  const [mostrarFiltroProfissional, setMostrarFiltroProfissional] =
    useState(false);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroCpf, setFiltroCpf] = useState("");
  const [filtroTelefone, setFiltroTelefone] = useState("");
  const [filtroEmail, setFiltroEmail] = useState("");

  useEffect(() => {
    fetchProfissionais();
    fetchEmpresas();
    fetchServicos();
  }, []);

  // Profissionais filtrados e ordenados
  const profissionaisFiltrados = useMemo(() => {
    return profissionais.filter((profissional) => {
      // Verifica filtro de nome (se filtroNome não estiver vazio)
      const nomeMatch =
        !filtroNome ||
        profissional.nome?.toLowerCase().includes(filtroNome.toLowerCase());

      // Verifica filtro de CPF (se filtroCpf não estiver vazio)
      const cpfMatch =
        !filtroCpf ||
        profissional.cpf?.toLowerCase().includes(filtroCpf.toLowerCase());

      // Verifica filtro de telefone (se filtroTelefone não estiver vazio)
      const telefoneMatch =
        !filtroTelefone ||
        profissional.telefone
          ?.toLowerCase()
          .includes(filtroTelefone.toLowerCase());

      // Verifica filtro de email (se filtroEmail não estiver vazio)
      const emailMatch =
        !filtroEmail ||
        profissional.email?.toLowerCase().includes(filtroEmail.toLowerCase());

      // Retorna true apenas se TODOS os filtros ativos corresponderem
      return nomeMatch && cpfMatch && telefoneMatch && emailMatch;
    });
  }, [profissionais, filtroNome, filtroCpf, filtroTelefone, filtroEmail]);

  const fetchProfissionais = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/profissionais",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Erro ao buscar profissionais");
      }

      const data = await response.json();

      if (data.success && Array.isArray(data.data)) {
        setProfissionais(data.data);
        setError(null);
      } else {
        setProfissionais([]);
        setError("Nenhum profissional encontrado.");
      }
    } catch (error) {
      setError(error.message);
      setProfissionais([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmpresas = async () => {
    try {
      if (!user?.token) return;

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          const options = data.data.map((empresa) => ({
            label: empresa.nome,
            value: empresa.id,
          }));
          setEmpresasOptions(options);
        }
      }
    } catch (error) {
      console.error("Erro ao buscar empresas:", error);
    }
  };

  const fetchServicos = async () => {
    try {
      if (!user?.token) throw new Error("Usuário não autenticado");

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/servicos",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) throw new Error("Erro ao buscar serviços");

      const data = await response.json();

      if (data.success && Array.isArray(data.data)) {
        setServicosDisponiveis(data.data);
      } else if (Array.isArray(data)) {
        setServicosDisponiveis(data);
      } else {
        setServicosDisponiveis([]);
      }
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
      setServicosDisponiveis([]);
    }
  };

  // Validar formulário de adicionar
  const validarFormulario = () => {
    return nome.trim() && cpf.trim() && cro.trim() && email && telefone;
  };

  //----------------------------------------------------------------------
  //-------------------------------- DATAS --------------------------------
  //----------------------------------------------------------------------

  const buscarDatasProfissional = async (profissionalId) => {
    try {
      setLoading(true);

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/datas-atendimento?profissional_id=${profissionalId}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        setDatasProfissional(data.data || []);
      } else {
        console.error(
          "Erro ao buscar datas:",
          response.status,
          response.statusText,
        );
        setDatasProfissional([]);
      }
    } catch (error) {
      console.error("Erro na requisição de buscar datas:", error);
      setDatasProfissional([]);
    } finally {
      setLoading(false);
    }
  };

  const gerarDiasCalendario = () => {
    const ano = mesCalendario.getFullYear();
    const mes = mesCalendario.getMonth();

    const primeiroDia = new Date(ano, mes, 1);
    const ultimoDia = new Date(ano, mes + 1, 0);
    const diaSemanaInicio = primeiroDia.getDay();

    const dias = [];

    // Dias do mês anterior
    for (let i = diaSemanaInicio - 1; i >= 0; i--) {
      const data = new Date(ano, mes, -i);
      dias.push({
        data,
        disponivel: false,
        selecionado: false,
        possuiAtendimento: false,
        outroMes: true,
      });
    }

    // Dias do mês atual
    for (let dia = 1; dia <= ultimoDia.getDate(); dia++) {
      const data = new Date(ano, mes, dia);
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      const dataFormatada = data.toISOString().split("T")[0];
      const possuiAtendimento = datasProfissional.some(
        (d) => d.data_atendimento === dataFormatada && d.ativo,
      );
      const selecionado = datasSelecionadas.some(
        (d) => d.toISOString().split("T")[0] === dataFormatada,
      );

      dias.push({
        data,
        disponivel: data >= hoje,
        selecionado,
        possuiAtendimento,
        outroMes: false,
      });
    }

    // Completar com dias do próximo mês
    const totalCells = 42;
    while (dias.length < totalCells) {
      const data = new Date(
        ano,
        mes + 1,
        dias.length - ultimoDia.getDate() - diaSemanaInicio + 1,
      );
      dias.push({
        data,
        disponivel: false,
        selecionado: false,
        possuiAtendimento: false,
        outroMes: true,
      });
    }

    return dias;
  };

  const handleSelecionarDia = (dia) => {
    if (!dia.disponivel && !dia.possuiAtendimento) return;

    // Permite selecionar APENAS:
    // - Dias disponíveis SEM atendimento (para adicionar)
    // - Dias que JÁ POSSUEM atendimento (para remover)
    if (!dia.disponivel && !dia.possuiAtendimento) return;
    if (dia.outroMes) return;

    const dataFormatada = new Date(dia.data);
    dataFormatada.setHours(0, 0, 0, 0);

    setDatasSelecionadas((prev) => {
      const existe = prev.some(
        (d) =>
          d.toISOString().split("T")[0] ===
          dataFormatada.toISOString().split("T")[0],
      );

      if (existe) {
        return prev.filter(
          (d) =>
            d.toISOString().split("T")[0] !==
            dataFormatada.toISOString().split("T")[0],
        );
      } else {
        return [...prev, dataFormatada].sort((a, b) => a - b);
      }
    });
  };

  const handleMudarMes = (direcao) => {
    const novoMes = new Date(mesCalendario);
    if (direcao === "proximo") {
      novoMes.setMonth(novoMes.getMonth() + 1);
    } else {
      novoMes.setMonth(novoMes.getMonth() - 1);
    }
    setMesCalendario(novoMes);
  };

  const handleSalvarDatas = async () => {
    if (datasSelecionadas.length === 0 || !profissionalEditandoId) return;

    try {
      setLoading(true);

      // Filtra apenas datas que NÃO existem no sistema
      const novasDatas = datasSelecionadas.filter((data) => {
        const dataFormatada = data.toISOString().split("T")[0];
        const dataExistente = datasProfissional.find(
          (d) => d.data_atendimento === dataFormatada && d.ativo,
        );
        return !dataExistente; // Só inclui se NÃO existir
      });

      if (novasDatas.length === 0) {
        setDialogMessage("Todas as datas selecionadas já estão cadastradas!");
        setShowErrorDialog(true);
        setLoading(false);
        return;
      }

      const promises = novasDatas.map(async (data) => {
        const dataFormatada = data.toISOString().split("T")[0];

        // Criar nova data
        const response = await fetch(
          "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/datas-atendimento",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${user.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              profissional_id: profissionalEditandoId,
              data_atendimento: dataFormatada,
              ativo: "1",
            }),
          },
        );

        const result = await response.json();
        if (!response.ok) {
          throw new Error(
            result.message || `Erro ao salvar data ${dataFormatada}`,
          );
        }

        return result;
      });

      await Promise.all(promises);

      // Recarregar datas
      await buscarDatasProfissional(profissionalEditandoId);

      setDialogMessage(
        `${novasDatas.length} data(s) adicionada(s) com sucesso!`,
      );
      setShowSuccessDialog(true);
      setVisibleDatasProfissional(false);
      setDatasSelecionadas([]);
    } catch (error) {
      console.error("Erro ao salvar datas:", error);
      setDialogMessage("Erro ao salvar algumas datas: " + error.message);
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoverDatas = async () => {
    if (datasSelecionadas.length === 0 || !profissionalEditandoId) return;

    try {
      setLoading(true);

      // Filtra apenas datas que EXISTEM no sistema
      const datasExistentes = datasSelecionadas.filter((data) => {
        const dataFormatada = data.toISOString().split("T")[0];
        const dataExistente = datasProfissional.find(
          (d) => d.data_atendimento === dataFormatada && d.ativo,
        );
        return !!dataExistente; // Só inclui se existir
      });

      if (datasExistentes.length === 0) {
        setDialogMessage(
          "Nenhuma das datas selecionadas está cadastrada para remoção!",
        );
        setShowErrorDialog(true);
        setLoading(false);
        return;
      }

      const promises = datasExistentes.map(async (data) => {
        const dataFormatada = data.toISOString().split("T")[0];

        // Encontrar a data no array de datas do profissional
        const dataExistente = datasProfissional.find(
          (d) => d.data_atendimento === dataFormatada && d.ativo,
        );

        if (dataExistente) {
          const response = await fetch(
            `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/datas-atendimento/${dataExistente.id}`,
            {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
              },
            },
          );

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(
              errorData.message || `Erro ao remover data ${dataFormatada}`,
            );
          }

          const result = await response.json();
          return result;
        } else {
          console.log(`Data ${dataFormatada} não encontrada`);
          return Promise.resolve();
        }
      });

      await Promise.all(promises);

      // Recarregar datas
      await buscarDatasProfissional(profissionalEditandoId);

      setDialogMessage(
        `${datasExistentes.length} data(s) removida(s) com sucesso!`,
      );
      setShowSuccessDialog(true);
      setVisibleDatasProfissional(false);
      setDatasSelecionadas([]);
    } catch (error) {
      console.error("Erro ao remover datas:", error);
      setDialogMessage("Erro ao remover algumas datas: " + error.message);
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleAdicionarTodosDias = () => {
    const dias = gerarDiasCalendario();

    // Filtra apenas os dias do mês atual que estão disponíveis
    const diasDisponiveis = dias.filter(
      (dia) => !dia.outroMes && dia.disponivel && !dia.possuiAtendimento,
    );

    // Pega as datas dos dias disponíveis
    const todasDatasDisponiveis = diasDisponiveis.map((dia) => {
      const data = new Date(dia.data);
      data.setHours(0, 0, 0, 0);
      return data;
    });

    // Atualiza o estado com todas as datas
    setDatasSelecionadas(todasDatasDisponiveis);
  };

  const getCorDiaModo = (dia, modo) => {
    if (dia.outroMes) return "#f8f9fa";
    if (dia.selecionado) return modo === "adicionar" ? "#007bff" : "#dc3545";
    if (dia.possuiAtendimento)
      return modo === "remover" ? "#f8d7da" : "#d4edda";
    if (!dia.disponivel) return "#f8f9fa";
    return "#ffffff";
  };

  const getCorTextoDiaModo = (dia, modo) => {
    if (dia.outroMes) return "#6c757d";
    if (dia.selecionado) return "#ffffff";
    if (dia.possuiAtendimento)
      return modo === "remover" ? "#721c24" : "#155724";
    if (!dia.disponivel) return "#6c757d";
    return "#424242";
  };

  //----------------------------------------------------------------------
  //-------------------------------- HORÁRIOS ----------------------------
  //----------------------------------------------------------------------

  // Na função buscarHorariosProfissional, também armazene o estado original
  const buscarHorariosProfissional = async (profissionalId) => {
    try {
      setLoading(true);
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/horarios-atendimento?profissional_id=${profissionalId}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        const horariosFormatados = data.data.map((item) => ({
          ...item,
          horarios: item.horarios
            ? ordenarHorarios(JSON.parse(item.horarios))
            : [],
        }));

        setHorariosProfissional(horariosFormatados);

        // MANTER O ESTADO INICIAL E SOMENTE ATUALIZAR OS DIAS QUE EXISTEM
        setHorariosEditando((prev) => {
          const novoEstado = { ...prev };

          // Também atualiza o estado original
          const novoOriginal = {};

          horariosFormatados.forEach((item) => {
            if (item.dia_semana >= 0 && item.dia_semana <= 6) {
              const horariosDoDia = ordenarHorarios(item.horarios || []);
              novoEstado[item.dia_semana] = horariosDoDia;
              novoOriginal[item.dia_semana] = [...horariosDoDia]; // Copia para estado original
            }
          });

          // Salva o estado original
          setHorariosOriginal(novoOriginal);

          return novoEstado;
        });
      } else {
        console.error("Erro ao buscar horários:", response.status);
        setHorariosProfissional([]);
        setHorariosOriginal({});
        setHorariosEditando({
          0: [],
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
          6: [],
        });
      }
    } catch (error) {
      console.error("Erro ao buscar horários:", error);
      setHorariosProfissional([]);
      setHorariosOriginal({});
      setHorariosEditando({
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
      });
    } finally {
      setLoading(false);
    }
  };

  const getNomeDiaSemana = (diaNumero) => {
    const dias = [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
    ];
    return dias[diaNumero] || "Dia inválido";
  };

  const handleMudarDia = (direcao) => {
    let novoDia;
    if (direcao === "proximo") {
      novoDia = diaSemanaEditando === 6 ? 0 : diaSemanaEditando + 1;
    } else {
      novoDia = diaSemanaEditando === 0 ? 6 : diaSemanaEditando - 1;
    }

    setDiaSemanaEditando(novoDia);

    // GARANTIR QUE SEMPRE EXISTA UM ARRAY PARA O DIA NO ESTADO
    const horariosDoNovoDia = horariosProfissional.find(
      (item) => item.dia_semana === novoDia,
    );

    setHorariosEditando((prev) => ({
      ...prev,
      [novoDia]: horariosDoNovoDia
        ? horariosDoNovoDia.horarios
        : prev[novoDia] || [], // Se não existir, usa array vazio
    }));
  };

  // Função para ordenar horários no formato HH:MM
  const ordenarHorarios = (horarios) => {
    if (!horarios || !Array.isArray(horarios)) {
      return [];
    }

    // Cria uma cópia para não mutar o array original
    const horariosCopiados = [...horarios];

    return horariosCopiados.sort((a, b) => {
      const [horaA, minutoA] = a.split(":").map(Number);
      const [horaB, minutoB] = b.split(":").map(Number);

      if (horaA !== horaB) {
        return horaA - horaB;
      }
      return minutoA - minutoB;
    });
  };

  const handleAdicionarHorarios = () => {
    setHorariosEditando((prev) => {
      const horariosAtuais = prev[diaSemanaEditando] || [];

      // Determinar o horário base
      let horaBase = 8;
      let minutoBase = 0;

      if (horariosAtuais.length > 0) {
        // Ordenar e pegar o maior horário
        const horariosOrdenados = ordenarHorarios(horariosAtuais);
        const ultimoHorario = horariosOrdenados[horariosOrdenados.length - 1];

        const [horaStr, minutoStr] = ultimoHorario.split(":");
        horaBase = parseInt(horaStr);
        minutoBase = parseInt(minutoStr);

        // Adicionar 1 hora
        horaBase += 1;

        // Se passar das 23h, volta para 8h
        if (horaBase >= 24) {
          horaBase = 8;
        }
      }

      // Formatar o novo horário
      const novoHorario = `${horaBase.toString().padStart(2, "0")}:${minutoBase.toString().padStart(2, "0")}`;

      // Adicionar e ordenar
      const novosHorarios = [...horariosAtuais, novoHorario];
      const horariosOrdenados = ordenarHorarios(novosHorarios);

      return {
        ...prev,
        [diaSemanaEditando]: horariosOrdenados,
      };
    });
  };

  const handleRemoverHorario = (diaSemana, index) => {
    setHorariosEditando((prev) => {
      const horariosAtuais = prev[diaSemana] || [];
      const novosHorarios = horariosAtuais.filter((_, i) => i !== index);
      return {
        ...prev,
        [diaSemana]: novosHorarios,
      };
    });
  };

  // Função para limpar o dia (chamada apenas quando clicar em SALVAR)
  const handleLimparHorariosDoDia = async () => {
    try {
      const diaSemanaParaAPI =
        diaSemanaEditando === 0 ? "0" : diaSemanaEditando;

      // Primeiro tenta DELETE
      let deleteResponse = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/horarios-atendimento",
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            profissional_id: profissionalEditandoId,
            dia_semana: diaSemanaParaAPI,
          }),
        },
      );

      if (deleteResponse.ok) {
        // DELETE funcionou
        const responseData = await deleteResponse.json();

        // Atualiza o estado local
        setHorariosProfissional((prev) =>
          prev.filter((item) => item.dia_semana !== diaSemanaEditando),
        );

        // Atualiza o estado original também
        setHorariosOriginal((prev) => {
          const novo = { ...prev };
          delete novo[diaSemanaEditando];
          return novo;
        });

        return {
          success: true,
          message: "Dia removido com sucesso!",
          method: "DELETE",
        };
      } else {
        // Se DELETE não funcionou, tenta POST com array vazio
        console.log("DEBUG - DELETE falhou, tentando POST com array vazio...");

        const postResponse = await fetch(
          "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/horarios-atendimento",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${user.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              profissional_id: profissionalEditandoId,
              dia_semana: diaSemanaParaAPI,
              horarios: [], // Array vazio
            }),
          },
        );

        const postData = await postResponse.json();

        if (postResponse.ok) {
          // Atualiza estados
          setHorariosProfissional((prev) =>
            prev.filter((item) => item.dia_semana !== diaSemanaEditando),
          );

          setHorariosOriginal((prev) => {
            const novo = { ...prev };
            delete novo[diaSemanaEditando];
            return novo;
          });

          return {
            success: true,
            message: "Dia removido com sucesso!",
            method: "POST",
          };
        } else {
          throw new Error(
            postData.message || "Erro ao remover horários (POST)",
          );
        }
      }
    } catch (error) {
      console.error("Erro ao remover dia:", error);
      return {
        success: false,
        message: "Erro ao remover dia: " + error.message,
      };
    }
  };

  const handleAtualizarHorario = (diaSemana, index, novoHorario) => {
    setHorariosEditando((prev) => {
      const horariosAtuais = prev[diaSemana] || [];
      const novosHorarios = [...horariosAtuais];
      novosHorarios[index] = novoHorario;

      // ORDENAR APÓS ATUALIZAR
      const horariosOrdenados = ordenarHorarios(novosHorarios);

      return {
        ...prev,
        [diaSemana]: horariosOrdenados,
      };
    });
  };

  const handleSalvarHorarios = async () => {
    try {
      setLoading(true);

      const horariosDoDia = horariosEditando[diaSemanaEditando] || [];
      const tinhaHorariosOriginalmente =
        horariosOriginal[diaSemanaEditando] &&
        horariosOriginal[diaSemanaEditando].length > 0;

      console.log("DEBUG - Estado atual:", {
        diaSemanaEditando,
        horariosDoDia,
        tinhaHorariosOriginalmente,
        horariosOriginal: horariosOriginal[diaSemanaEditando],
      });

      // SE O DIA ESTIVER VAZIO
      if (horariosDoDia.length === 0) {
        if (tinhaHorariosOriginalmente) {
          // Se tinha horários originalmente e agora está vazio, remove o dia
          const resultado = await handleLimparHorariosDoDia();
          if (resultado.success) {
            setDialogMessage(resultado.message);
            setShowSuccessDialog(true);
            setVisibleHorariosProfissional(false);
          } else {
            throw new Error(resultado.message);
          }
        } else {
          // Se não tinha horários originalmente e está vazio, mostra mensagem
          throw new Error("Adicione pelo menos um horário para salvar");
        }
        return;
      }

      // SE HOUVER HORÁRIOS PARA SALVAR
      const horariosOrdenados = ordenarHorarios([...horariosDoDia]);
      const diaSemanaParaAPI =
        diaSemanaEditando === 0 ? "0" : diaSemanaEditando;

      const requestBody = {
        profissional_id: profissionalEditandoId,
        dia_semana: diaSemanaParaAPI,
        horarios: horariosOrdenados,
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/horarios-atendimento",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      const responseData = await response.json();
      console.log("DEBUG - Resposta da API:", responseData);

      if (response.ok) {
        await buscarHorariosProfissional(profissionalEditandoId);

        // DIFERENCIAR MENSAGEM
        if (tinhaHorariosOriginalmente) {
          setDialogMessage("Horários atualizados com sucesso!");
        } else {
          setDialogMessage("Horários salvos com sucesso!");
        }

        setShowSuccessDialog(true);
        setVisibleHorariosProfissional(false);
      } else {
        throw new Error(responseData.message || "Erro ao salvar horários");
      }
    } catch (error) {
      console.error("Erro ao salvar horários:", error);
      setDialogMessage("Erro ao salvar horários: " + error.message);
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  //----------------------------------------------------------------------
  //-------------------------------- SERVIÇOS ----------------------------
  //----------------------------------------------------------------------

  const buscarServicosProfissional = async (profissionalId) => {
    try {
      console.log("📋 Buscando serviços do profissional:", profissionalId);

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/profissionais/${profissionalId}/servicos`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        },
      );

      if (!response.ok)
        throw new Error(`HTTP ${response.status} - ${response.statusText}`);

      const servicos = await response.json();
      console.log("✅ Serviços carregados:", servicos);

      const servicosArray = Array.isArray(servicos)
        ? servicos
        : servicos.data && Array.isArray(servicos.data)
          ? servicos.data
          : [];

      setServicosAssociados(servicosArray);
      setServicosSelecionados(servicosArray);
      setServicosParaAdicionar([]);
      setServicosParaRemover([]);
    } catch (error) {
      console.error("❌ Erro ao carregar serviços:", error);
      setServicosAssociados([]);
      setServicosSelecionados([]);
      setServicosParaAdicionar([]);
      setServicosParaRemover([]);
    }
  };

  const handleSalvarServicos = async () => {
    try {
      // --- DESASSOCIAR ---
      if (servicosParaRemover.length > 0) {
        console.log("🗑️ === INICIANDO REMOÇÃO ===");
        for (const servicoId of servicosParaRemover) {
          console.log("Removendo serviço:", servicoId);

          const response = await fetch(
            `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/profissionais/${profissionalEditandoId}/servicos/${servicoId}/remover`,
            {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
              },
            },
          );

          const result = await response.json();
          console.log(`Resposta remoção ${servicoId}:`, result);

          if (!response.ok) {
            throw new Error(
              `Erro ao remover serviço ${servicoId}: ${result.message}`,
            );
          }
        }
      }

      // --- ASSOCIAR ---
      if (servicosParaAdicionar.length > 0) {
        console.log("➕ === INICIANDO ASSOCIAÇÃO ===");
        for (const servicoId of servicosParaAdicionar) {
          console.log("Adicionando serviço:", servicoId);
          const servico = servicosDisponiveis.find((s) => s.id === servicoId);

          if (!servico) {
            console.warn(
              `Serviço ${servicoId} não encontrado em servicosDisponiveis`,
            );
            continue;
          }

          const response = await fetch(
            `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/profissionais/${profissionalEditandoId}/servicos/${servicoId}/associar`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                valor: servico.valor || servico.valor_base || "0.00",
              }),
            },
          );

          const result = await response.json();
          console.log(`Resposta associação ${servicoId}:`, result);

          if (!response.ok) {
            throw new Error(
              `Erro ao adicionar serviço ${servicoId}: ${result.message}`,
            );
          }
        }
      }

      // Atualiza estados locais
      setServicosAssociados(servicosSelecionados);
      setServicosParaAdicionar([]);
      setServicosParaRemover([]);

      console.log("✅ === SALVAMENTO CONCLUÍDO ===");
      setVisibleServicosProfissional(false);
      setDialogMessage("Serviços salvos com sucesso!");
      setShowSuccessDialog(true);
    } catch (error) {
      console.error("❌ === ERRO DETALHADO ===", error);
      setDialogMessage("Erro ao salvar: " + error.message);
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleAdicionarServico = (novosServicos) => {
    if (!novosServicos || novosServicos.length === 0) return;

    console.log("➕ Adicionando serviços:", novosServicos);

    const novosIds = novosServicos.map((s) => s.id);
    const idsAtuais = servicosSelecionados.map((s) => s.id);

    // Encontra os IDs que foram adicionados
    const idsAdicionados = novosIds.filter((id) => !idsAtuais.includes(id));

    if (idsAdicionados.length > 0) {
      // Adiciona aos selecionados
      const servicosParaAdicionarObj = servicosDisponiveis.filter((s) =>
        idsAdicionados.includes(s.id),
      );

      setServicosSelecionados((prev) => [...prev, ...servicosParaAdicionarObj]);
      setServicosParaAdicionar((prev) => [...prev, ...idsAdicionados]);

      // Remove da lista de remoção se estava lá
      setServicosParaRemover((prev) =>
        prev.filter((id) => !idsAdicionados.includes(id)),
      );

      console.log("✅ Serviços adicionados:", idsAdicionados);
    }
  };

  const handleRemoverServico = (servicoId) => {
    console.log("🗑️ Removendo serviço:", servicoId);
    console.log(
      "Associados:",
      servicosAssociados.map((s) => s.id),
    );
    console.log("Para adicionar:", servicosParaAdicionar);

    // Remove da lista de selecionados
    setServicosSelecionados((prev) => prev.filter((s) => s.id !== servicoId));

    // Verifica se era um serviço originalmente associado
    const eraAssociado = servicosAssociados.some((s) => s.id === servicoId);
    const estavaParaAdicionar = servicosParaAdicionar.includes(servicoId);

    console.log(
      `Era associado: ${eraAssociado}, Estava para adicionar: ${estavaParaAdicionar}`,
    );

    if (eraAssociado && !estavaParaAdicionar) {
      // Serviço que existia no banco e não foi adicionado agora → marca para remover
      setServicosParaRemover((prev) => [...prev, servicoId]);
      console.log("✅ Marcado para REMOÇÃO do banco");
    } else if (estavaParaAdicionar) {
      // Serviço que foi adicionado agora → só remove da lista de adição
      setServicosParaAdicionar((prev) => prev.filter((id) => id !== servicoId));
      console.log("❌ Removido da lista de ADIÇÃO");
    }
  };

  const resetarCampos = () => {
    setNome("");
    setEmail("");
    setTelefone("");
    setCpf("");
    setRg("");
    setCro("");
    setLogradouro("");
    setNumero("");
    setBairro("");
    setCidade("");
    setEstado("");
    setCep("");
    setAtivo(true);
    setEmpresasSelecionadas([]);
    setHorariosEditando({});
  };

  const handleSalvar = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      // Verificação dos campos obrigatórios
      if (!nome || !telefone || !email || empresasSelecionadas.length === 0) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      const profissionalData = {
        nome: nome,
        email: email,
        telefone: telefone,
        cpf: cpf,
        rg: rg,
        cro: cro,
        especialidade: especialidade,
        logradouro: logradouro,
        numero: numero,
        bairro: bairro,
        cidade: cidade,
        estado: estado,
        cep: cep,
        ativo: ativo ? "1" : "0",
        empresas: empresasSelecionadas,
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/profissionais",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(profissionalData),
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Falha ao cadastrar profissional");
      }

      await response.json();
      setDialogMessage("Profissional cadastrado com sucesso!");
      setShowSuccessDialog(true);
      fetchProfissionais();
      setVisibleNovoProfissional(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro detalhado ao salvar:", err);
      setDialogMessage(err.message || "Erro ao cadastrar profissional");
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEditar = async (profissionalId) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      if (!nome || !telefone || !email) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      const profissionalData = {
        nome: nome,
        email: email,
        telefone: telefone,
        cpf: cpf,
        rg: rg,
        cro: cro,
        especialidade: especialidade,
        logradouro: logradouro,
        numero: numero,
        bairro: bairro,
        cidade: cidade,
        estado: estado,
        cep: cep,
        ativo: ativo ? "1" : "0",
        empresas: empresasSelecionadas,
      };

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/profissionais/${profissionalId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(profissionalData),
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData?.message ||
          responseData?.data?.message ||
          `Erro HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      setDialogMessage("Profissional atualizado com sucesso!");
      setShowSuccessDialog(true);
      fetchProfissionais();
      setVisibleEditarProfissional(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro na edição:", err);
      setDialogMessage(
        err.message.includes("não encontrada")
          ? "Profissional não encontrado ou já removido"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const toggleFiltroProfissional = () => {
    setMostrarFiltroProfissional(!mostrarFiltroProfissional);
    if (mostrarFiltroProfissional) {
      setFiltroNome("");
    }
  };

  {
    /* Return Principal */
  }
  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Dialog de Sucesso */}
      <Dialog
        visible={showSuccessDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowSuccessDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#22C55E",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-check-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            icon="pi pi-check"
            onClick={() => setShowSuccessDialog(false)}
            className="p-button-success"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog de Erro */}
      <Dialog
        visible={showErrorDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowErrorDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#EF4444",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-times-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            onClick={() => setShowErrorDialog(false)}
            className="p-button-danger"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog Novo Profissional */}
      <Dialog
        visible={visibleNovoProfissional}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleNovoProfissional(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaUserMd style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ADICIONAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PROFISSIONAL
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "20px 0" }}>
            {/* 1ª Linha - Nome e CPF */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaUserMd
                      style={{ color: "#3498DB", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Nome *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Nome do Profissional"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card CPF */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaIdCard
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CPF *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="000.000.000-00"
                    value={cpf}
                    onChange={(e) => setCpf(e.target.value)}
                    mask="999.999.999-99"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 2ª Linha - Rg e Data Nascimento */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Rg */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #D35400",
                    }}
                  >
                    <FaIdCard
                      style={{ color: "#D35400", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Rg *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Rg do Profissional"
                    value={rg}
                    onChange={(e) => setRg(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card CRO */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498db",
                    }}
                  >
                    <FaIdCard
                      style={{ color: "#3498db", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CRO *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="CRO do Profissional"
                    value={cro}
                    onChange={(e) => setCro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Data Nascimento */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaUserGraduate
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Especialidade *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Especialidade do Profissional"
                    value={especialidade}
                    onChange={(e) => setEspecialidade(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 3ª Linha - Email e Telefone */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Telefone */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaPhone style={{ color: "#2980B9", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Telefone *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="(00) 0000-0000"
                    value={telefone}
                    mask="(99) 9999-9999"
                    onChange={(e) => setTelefone(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Email */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #D35400",
                    }}
                  >
                    <FaEnvelope
                      style={{ color: "#D35400", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Email *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="email@paciente.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Data Nascimento */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaUserMd
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Data Nascimento *
                    </span>
                  </div>
                  <InputMask
                    className="p-inputtext-sm"
                    placeholder="00/00/0000"
                    value={dtNascimento}
                    onChange={(e) => setDtNascimento(e.target.value)}
                    mask="99/99/9999"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 4 linha - Endereço, Número e Bairro */}
            <div className="grid-endereco-numero-bairro">
              {/* Card Endereço */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #16A085",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#16A085", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Endereço
                    </span>
                  </div>
                  <InputText
                    placeholder="Rua, Avenida, etc."
                    value={logradouro}
                    onChange={(e) => setLogradouro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Número */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #8E44AD",
                    }}
                  >
                    <FaMapPin
                      style={{ color: "#8E44AD", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Número
                    </span>
                  </div>
                  <InputText
                    placeholder="Número"
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Bairro */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #F1C40F",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#F1C40F", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Bairro
                    </span>
                  </div>
                  <InputText
                    placeholder="Bairro"
                    value={bairro}
                    onChange={(e) => setBairro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 5ª Linha - Cidade, Estado e CEP */}
            <div className="grid-endereco-numero-bairro">
              {/* Card Cidade */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #27AE60",
                    }}
                  >
                    <FaCity style={{ color: "#27AE60", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Cidade
                    </span>
                  </div>
                  <InputText
                    placeholder="Cidade"
                    value={cidade}
                    onChange={(e) => setCidade(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Estado */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E74C3C",
                    }}
                  >
                    <FaGlobeAmericas
                      style={{ color: "#E74C3C", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Estado
                    </span>
                  </div>
                  <InputText
                    placeholder="Uf"
                    value={estado}
                    onChange={(e) => setEstado(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card CEP */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #95A5A6",
                    }}
                  >
                    <FaMailBulk
                      style={{ color: "#95A5A6", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CEP
                    </span>
                  </div>
                  <InputMask
                    placeholder="00.000-000"
                    value={cep}
                    onChange={(e) => setCep(e.target.value)}
                    mask="99.999-999"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 6ª Linha - Empresas */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Telefone */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaBuilding
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Empresa(s)
                    </span>
                  </div>
                  <MultiSelect
                    value={empresasSelecionadas}
                    options={empresasOptions}
                    onChange={(e) => setEmpresasSelecionadas(e.value)}
                    placeholder="Selecione as empresas"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      alignItems: "center",
                    }}
                    showClear
                    itemTemplate={(option) => (
                      <div
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.85rem",
                        }}
                      >
                        {option.label}
                      </div>
                    )}
                    valueTemplate={(selectedValues, props) => {
                      if (!selectedValues || selectedValues.length === 0) {
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.85rem",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      }
                      const labels = empresasOptions
                        .filter((opt) => selectedValues.includes(opt.value))
                        .map((opt) => opt.label);
                      return (
                        <span style={{ fontFamily: "'Rajdhani', sans-serif" }}>
                          {labels.join(", ")}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleNovoProfissional(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "CADASTRAR PROFISSIONAL"}
              icon="pi pi-check"
              onClick={handleSalvar}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={
                loading ||
                !validarFormulario() ||
                empresasSelecionadas.length == 0
              }
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog EDITAR */}
      <Dialog
        visible={visibleEditarProfissional}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleEditarProfissional(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaUserMd style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  EDITAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PROFISSIONAL
                </div>
              </div>
            </div>
          </div>
        }
      >
        {profissionalEditandoId && (
          <>
            {/* Formulário em Cards */}
            <div style={{ padding: "20px 0" }}>
              {/* 1ª Linha - Nome e CPF */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                {/* Card Nome */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498DB",
                      }}
                    >
                      <FaUserMd
                        style={{ color: "#3498DB", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Nome *
                      </span>
                    </div>
                    <InputText
                      className="p-inputtext-sm"
                      placeholder="Nome do Profissional"
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>

                {/* Card CPF */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #E67E22",
                      }}
                    >
                      <FaIdCard
                        style={{ color: "#E67E22", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        CPF *
                      </span>
                    </div>
                    <InputMask
                      className="p-inputtext-sm"
                      placeholder="000.000.000-00"
                      value={cpf}
                      onChange={(e) => setCpf(e.target.value)}
                      mask="999.999.999-99"
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* 2ª Linha - Rg e Data Nascimento */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                {/* Card Rg */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #D35400",
                      }}
                    >
                      <FaIdCard
                        style={{ color: "#D35400", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Rg *
                      </span>
                    </div>
                    <InputText
                      className="p-inputtext-sm"
                      placeholder="Rg do Profissional"
                      value={rg}
                      onChange={(e) => setRg(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>

                {/* Card CRO */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498db",
                      }}
                    >
                      <FaIdCard
                        style={{ color: "#3498db", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        CRO *
                      </span>
                    </div>
                    <InputText
                      className="p-inputtext-sm"
                      placeholder="CRO do Profissional"
                      value={cro}
                      onChange={(e) => setCro(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>

                {/* Card Data Nascimento */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #2980B9",
                      }}
                    >
                      <FaUserGraduate
                        style={{ color: "#2980B9", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Especialidade *
                      </span>
                    </div>
                    <InputText
                      className="p-inputtext-sm"
                      placeholder="Especialidade do Profissional"
                      value={especialidade}
                      onChange={(e) => setEspecialidade(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* 3ª Linha - Email e Telefone */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                {/* Card Telefone */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #2980B9",
                      }}
                    >
                      <FaPhone
                        style={{ color: "#2980B9", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Telefone *
                      </span>
                    </div>
                    <InputMask
                      className="p-inputtext-sm"
                      placeholder="(00) 0000-0000"
                      value={telefone}
                      mask="(99) 9999-9999"
                      onChange={(e) => setTelefone(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>

                {/* Card Email */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #D35400",
                      }}
                    >
                      <FaEnvelope
                        style={{ color: "#D35400", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Email *
                      </span>
                    </div>
                    <InputText
                      className="p-inputtext-sm"
                      placeholder="email@paciente.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>

                {/* Card Data Nascimento */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #2980B9",
                      }}
                    >
                      <FaUserMd
                        style={{ color: "#2980B9", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Data Nascimento *
                      </span>
                    </div>
                    <InputMask
                      className="p-inputtext-sm"
                      placeholder="00/00/0000"
                      value={dtNascimento}
                      onChange={(e) => setDtNascimento(e.target.value)}
                      mask="99/99/9999"
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* 4 linha - Endereço, Número e Bairro */}
              <div className="grid-endereco-numero-bairro">
                {/* Card Endereço */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #16A085",
                      }}
                    >
                      <FaMapMarkerAlt
                        style={{ color: "#16A085", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Endereço
                      </span>
                    </div>
                    <InputText
                      placeholder="Rua, Avenida, etc."
                      value={logradouro}
                      onChange={(e) => setLogradouro(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "0 10px",
                      }}
                    />
                  </div>
                </div>
                {/* Card Número */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #8E44AD",
                      }}
                    >
                      <FaMapPin
                        style={{ color: "#8E44AD", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Número
                      </span>
                    </div>
                    <InputText
                      placeholder="Número"
                      value={numero}
                      onChange={(e) => setNumero(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "0 10px",
                      }}
                    />
                  </div>
                </div>
                {/* Card Bairro */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #F1C40F",
                      }}
                    >
                      <FaMapMarkerAlt
                        style={{ color: "#F1C40F", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Bairro
                      </span>
                    </div>
                    <InputText
                      placeholder="Bairro"
                      value={bairro}
                      onChange={(e) => setBairro(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "0 10px",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* 5ª Linha - Cidade, Estado e CEP */}
              <div className="grid-endereco-numero-bairro">
                {/* Card Cidade */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #27AE60",
                      }}
                    >
                      <FaCity
                        style={{ color: "#27AE60", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Cidade
                      </span>
                    </div>
                    <InputText
                      placeholder="Cidade"
                      value={cidade}
                      onChange={(e) => setCidade(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "0 10px",
                      }}
                    />
                  </div>
                </div>
                {/* Card Estado */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #E74C3C",
                      }}
                    >
                      <FaGlobeAmericas
                        style={{ color: "#E74C3C", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Estado
                      </span>
                    </div>
                    <InputText
                      placeholder="Uf"
                      value={estado}
                      onChange={(e) => setEstado(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "0 10px",
                      }}
                    />
                  </div>
                </div>
                {/* Card CEP */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #95A5A6",
                      }}
                    >
                      <FaMailBulk
                        style={{ color: "#95A5A6", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        CEP
                      </span>
                    </div>
                    <InputMask
                      placeholder="00.000-000"
                      value={cep}
                      onChange={(e) => setCep(e.target.value)}
                      mask="99.999-999"
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "0 10px",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* 6ª Linha - Empresas */}
              <div className="grid-empresa-ativo">
                {/* Card Endereço */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #E74C3C",
                      }}
                    >
                      <FaBuilding
                        style={{ color: "#E74C3C", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Empresa *
                      </span>
                    </div>
                    <MultiSelect
                      value={empresasSelecionadas}
                      options={empresasOptions}
                      onChange={(e) => setEmpresasSelecionadas(e.value)}
                      placeholder="Selecione as empresas"
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        alignItems: "center",
                      }}
                      showClear
                      itemTemplate={(option) => (
                        <div
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.85rem",
                          }}
                        >
                          {option.label}
                        </div>
                      )}
                      valueTemplate={(selectedValues, props) => {
                        if (!selectedValues || selectedValues.length === 0) {
                          return (
                            <span
                              style={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.85rem",
                              }}
                            >
                              {props.placeholder}
                            </span>
                          );
                        }
                        const labels = empresasOptions
                          .filter((opt) => selectedValues.includes(opt.value))
                          .map((opt) => opt.label);
                        return (
                          <span
                            style={{ fontFamily: "'Rajdhani', sans-serif" }}
                          >
                            {labels.join(", ")}
                          </span>
                        );
                      }}
                    />
                  </div>
                </div>

                {/* Card Ativo */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #2980B9",
                      }}
                    >
                      <FaCheckCircle
                        style={{ color: "#2980B9", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Ativo *
                      </span>
                    </div>
                    <Checkbox
                      checked={ativo}
                      onChange={(e) => setAtivo(e.checked)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Botão Fechar */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                flexWrap: "wrap",
              }}
            >
              <Button
                label="CANCELAR"
                icon="pi pi-times"
                onClick={() => {
                  resetarCampos();
                  setVisibleEditarProfissional(false);
                }}
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "8px 24px",
                  minWidth: "120px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
                disabled={loading}
              />
              <Button
                label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
                icon="pi pi-check"
                onClick={() => handleEditar(profissionalEditandoId)}
                className="p-button-success p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "8px 24px",
                  minWidth: "160px",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
                disabled={loading || !validarFormulario()}
                loading={loading}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* Dialog Datas do Profissional */}
      <Dialog
        visible={visibleDatasProfissional}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => !loading && setVisibleDatasProfissional(false)}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaCalendarAlt
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  DATAS DE ATENDIMENTO
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PROFISSIONAL
                </div>
              </div>
            </div>
          </div>
        }
      >
        {/* Formulário em Cards */}
        <div style={{ padding: "20px 0" }}>
          {/* Card Principal - Controle de Datas */}
          <div
            style={{
              display: "grid",
              backgroundColor: "#fafafa",
              border: "1px solid #e8e8e8",
              padding: "15px",
              borderRadius: "6px",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
              }}
            >
              {/* Cabeçalho do Card */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingBottom: "10px",
                  borderBottom: "2px solid #3498DB",
                }}
              >
                {/* Título do Card */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <FaCalendarAlt
                    style={{ color: "#3498DB", fontSize: "1rem" }}
                  />
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#2c3e50",
                      fontSize: "1rem",
                      letterSpacing: "0.3px",
                    }}
                  >
                    Selecione as Datas
                  </span>
                </div>

                {/* Seletor de Mês - Alinhado à Direita */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      icon="pi pi-chevron-left"
                      className="p-button-text p-button-sm"
                      onClick={() => handleMudarMes("anterior")}
                      tooltip="Mês anterior"
                      style={{
                        padding: "5px",
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                        color: "#424242",
                      }}
                    />

                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#424242",
                        textAlign: "center",
                      }}
                    >
                      {mesCalendario
                        .toLocaleDateString("pt-BR", {
                          month: "long",
                          year: "numeric",
                        })
                        .toUpperCase()}
                    </span>

                    <Button
                      icon="pi pi-chevron-right"
                      className="p-button-text p-button-sm"
                      onClick={() => handleMudarMes("proximo")}
                      tooltip="Próximo mês"
                      style={{
                        padding: "5px",
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                        color: "#424242",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Botão Adicionar Todos os Dias (agora sempre visível) */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  padding: "10px",
                  backgroundColor: "#fff",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                }}
              >
                <Button
                  label="ADICIONAR TODOS OS DIAS DISPONÍVEIS"
                  icon="pi pi-calendar-plus"
                  onClick={handleAdicionarTodosDias}
                  className="p-button-success p-button-sm"
                  style={{
                    outline: "none",
                    boxShadow: "0 2px 4px rgba(40, 167, 69, 0.2)",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    // borderColor: "#007BFF",
                    // backgroundColor: "#007BFF",
                    color: "white",
                    fontWeight: "600",
                    fontSize: "0.8rem",
                    fontFamily: "'Rajdhani', sans-serif",
                  }}
                  tooltip="Marcar todos os dias disponíveis do mês"
                  tooltipOptions={{ position: "top" }}
                />
              </div>

              {/* Calendário Visual */}
              <div
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(7, 1fr)",
                    gap: "2px",
                    marginBottom: "10px",
                  }}
                >
                  {/* Cabeçalho dos dias da semana */}
                  {["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"].map(
                    (dia) => (
                      <div
                        key={dia}
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          padding: "5px 2px",
                          backgroundColor: "#e9ecef",
                          borderRadius: "3px",
                          fontSize: "0.8rem",
                          color: "#495057",
                        }}
                      >
                        {dia}
                      </div>
                    ),
                  )}

                  {/* Dias do calendário - Agora permite selecionar tanto disponíveis quanto já cadastrados */}
                  {gerarDiasCalendario().map((dia, index) => {
                    // Determina se o dia é selecionável
                    const isSelectable =
                      (dia.disponivel && !dia.possuiAtendimento) ||
                      dia.possuiAtendimento;

                    // Determina a cor de fundo
                    let backgroundColor;
                    if (dia.selecionado) {
                      backgroundColor = "#007bff"; // Azul para selecionado
                    } else if (dia.possuiAtendimento) {
                      backgroundColor = "#d4edda"; // Verde claro para já cadastrado
                    } else if (dia.disponivel && !dia.outroMes) {
                      backgroundColor = "#ffffff"; // Branco para disponível
                    } else {
                      backgroundColor = "#f8f9fa"; // Cinza para indisponível
                    }

                    // Determina a cor do texto
                    let color;
                    if (dia.selecionado) {
                      color = "#ffffff";
                    } else if (dia.possuiAtendimento) {
                      color = "#155724";
                    } else if (dia.disponivel && !dia.outroMes) {
                      color = "#424242";
                    } else {
                      color = "#6c757d";
                    }

                    return (
                      <div
                        key={index}
                        onClick={() => {
                          if (isSelectable) {
                            handleSelecionarDia(dia);
                          }
                        }}
                        style={{
                          textAlign: "center",
                          padding: "10px 1px",
                          backgroundColor: backgroundColor,
                          borderRadius: "4px",
                          cursor: isSelectable ? "pointer" : "not-allowed",
                          border: "1px solid #dee2e6",
                          fontWeight: dia.selecionado ? "bold" : "normal",
                          color: color,
                          position: "relative",
                          minHeight: "40px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "0.85rem",
                          transition: "all 0.2s ease",
                        }}
                        className={isSelectable ? "day-hover" : ""}
                      >
                        <div
                          style={{
                            fontWeight:
                              dia.data.getDate() === new Date().getDate()
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {dia.data.getDate()}
                        </div>
                        {dia.possuiAtendimento && (
                          <div
                            style={{
                              position: "absolute",
                              top: "3px",
                              right: "3px",
                              width: "6px",
                              height: "6px",
                              backgroundColor: "#28a745",
                              borderRadius: "50%",
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Legenda */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "15px",
                    flexWrap: "wrap",
                    fontSize: "0.75rem",
                    paddingTop: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#ffffff",
                        border: "1px solid #dee2e6",
                        borderRadius: "2px",
                      }}
                    ></div>
                    <span style={{ color: "#6c757d" }}>
                      Disponível para adicionar
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#d4edda",
                        border: "1px solid #c3e6cb",
                        borderRadius: "2px",
                      }}
                    ></div>
                    <span style={{ color: "#6c757d" }}>
                      Já cadastrado (clique para remover)
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#007bff",
                        borderRadius: "2px",
                      }}
                    ></div>
                    <span style={{ color: "#6c757d" }}>Selecionado</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #dee2e6",
                        borderRadius: "2px",
                      }}
                    ></div>
                    <span style={{ color: "#6c757d" }}>Indisponível</span>
                  </div>
                </div>
              </div>

              {/* Resumo das datas selecionadas */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: "5px",
                  borderTop: "1px solid #e8e8e8",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "0.85rem",
                    color: "#7f8c8d",
                  }}
                >
                  <FaCalendar style={{ fontSize: "0.9rem" }} />
                  <span>
                    {(datasSelecionadas || []).length} data(s) selecionada(s)
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  {datasSelecionadas.length > 0 && (
                    <div
                      style={{
                        fontSize: "0.75rem",
                        color: "#007bff",
                        backgroundColor: "#e3f2fd",
                        padding: "3px 10px",
                        borderRadius: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {datasSelecionadas.length} datas selecionadas
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botões de Ação */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
            flexWrap: "wrap",
          }}
        >
          <Button
            label="CANCELAR"
            icon="pi pi-times"
            onClick={() => {
              setDatasSelecionadas([]);
              setVisibleDatasProfissional(false);
            }}
            className="p-button-outlined p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "6px 20px",
              minWidth: "100px",
              borderColor: "#dee2e6",
              color: "#495057",
              fontWeight: "500",
              fontSize: "0.875rem",
            }}
            disabled={loading}
          />

          {/* Verifica se há alguma data selecionada que NÃO existe no sistema */}
          {datasSelecionadas.some((data) => {
            const dataFormatada = data.toISOString().split("T")[0];
            return !datasProfissional.some(
              (d) => d.data_atendimento === dataFormatada && d.ativo,
            );
          }) && (
            <Button
              label={
                loading ? "PROCESSANDO..." : "ADICIONAR DATAS SELECIONADAS"
              }
              icon="pi pi-plus"
              onClick={handleSalvarDatas}
              className="p-button-success"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "220px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={datasSelecionadas.length === 0 || loading}
              loading={loading}
            />
          )}

          {/* Verifica se há alguma data selecionada que JÁ EXISTE no sistema */}
          {datasSelecionadas.some((data) => {
            const dataFormatada = data.toISOString().split("T")[0];
            return datasProfissional.some(
              (d) => d.data_atendimento === dataFormatada && d.ativo,
            );
          }) && (
            <Button
              label={loading ? "PROCESSANDO..." : "REMOVER DATAS SELECIONADAS"}
              icon="pi pi-trash"
              onClick={handleRemoverDatas}
              className="p-button-danger"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "220px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={datasSelecionadas.length === 0 || loading}
              loading={loading}
            />
          )}
        </div>
      </Dialog>

      {/* Dialog Horários do Profissional */}
      <Dialog
        visible={visibleHorariosProfissional}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => !loading && setVisibleHorariosProfissional(false)}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaClock style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  HORÁRIOS DE ATENDIMENTO
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PROFISSIONAL
                </div>
              </div>
            </div>
          </div>
        }
      >
        {/* Formulário em Cards */}
        <div style={{ padding: "20px 0" }}>
          {/* Card Principal - Controle de Horários */}
          <div
            style={{
              display: "grid",
              backgroundColor: "#fafafa",
              border: "1px solid #e8e8e8",
              padding: "15px",
              borderRadius: "6px",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
              }}
            >
              {/* Cabeçalho do Card */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingBottom: "10px",
                  borderBottom: "2px solid #3498DB",
                }}
              >
                {/* Título do Card */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <FaClock style={{ color: "#3498DB", fontSize: "1rem" }} />
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#2c3e50",
                      fontSize: "1rem",
                      letterSpacing: "0.3px",
                    }}
                  >
                    Controle de Horários
                  </span>
                </div>

                {/* Seletor de Dia - Alinhado à Direita */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      icon="pi pi-chevron-left"
                      className="p-button-text p-button-sm"
                      onClick={() => handleMudarDia("anterior")}
                      tooltip="Dia anterior"
                      style={{
                        padding: "5px",
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                        color: "#424242",
                      }}
                    />

                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#424242",
                        textAlign: "center",
                      }}
                    >
                      {getNomeDiaSemana(diaSemanaEditando).toUpperCase()}
                    </span>

                    <Button
                      icon="pi pi-chevron-right"
                      className="p-button-text p-button-sm"
                      onClick={() => handleMudarDia("proximo")}
                      tooltip="Próximo dia"
                      style={{
                        padding: "5px",
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                        color: "#424242",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  padding: "10px",
                  backgroundColor: "#fff",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                }}
              >
                <Button
                  label="ADICIONAR HORÁRIO"
                  icon="pi pi-plus"
                  onClick={handleAdicionarHorarios}
                  className="p-button-success p-button-sm"
                  style={{
                    outline: "none",
                    boxShadow: "0 2px 4px rgba(40, 167, 69, 0.2)",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    // borderColor: "#007BFF",
                    // backgroundColor: "#007BFF",
                    color: "white",
                    fontWeight: "600",
                    fontSize: "0.8rem",
                    fontFamily: "'Rajdhani', sans-serif",
                  }}
                  tooltip="Marcar todos os dias disponíveis do mês"
                  tooltipOptions={{ position: "top" }}
                />
              </div>
              {/* Área dos Horários */}
              <div style={{ marginBottom: "10px" }}>
                {(horariosEditando[diaSemanaEditando] || []).length > 0 ? (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(280px, 1fr))",
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {horariosEditando[diaSemanaEditando].map(
                      (horario, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "10px 12px",
                            backgroundColor: "#fff",
                            border: "1px solid #e8e8e8",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {/* Número de Ordem */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "24px",
                              height: "24px",
                              backgroundColor: "#3498DB",
                              color: "white",
                              borderRadius: "50%",
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              flexShrink: 0,
                            }}
                          >
                            {index + 1}
                          </div>

                          {/* Campo de Horário */}
                          <InputMask
                            value={horario}
                            onChange={(e) =>
                              handleAtualizarHorario(
                                diaSemanaEditando,
                                index,
                                e.target.value,
                              )
                            }
                            mask="99:99"
                            placeholder="10:00"
                            style={{
                              flex: 1,
                              border: "1px solid #dee2e6",
                              backgroundColor: "white",
                              borderRadius: "4px",
                              outline: "none",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              color: "#2c3e50",
                              fontFamily: "'Rajdhani', sans-serif",
                              padding: "8px 12px",
                              textAlign: "center",
                            }}
                          />

                          {/* Botão Remover */}
                          <Button
                            icon="pi pi-trash"
                            onClick={() =>
                              handleRemoverHorario(diaSemanaEditando, index)
                            }
                            className="p-button-danger p-button-sm"
                            style={{
                              width: "28px",
                              height: "28px",
                              flexShrink: 0,
                            }}
                            tooltip="Remover horário"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      ),
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "5px",
                      backgroundColor: "#fafafa",
                      border: "2px dashed #dee2e6",
                      borderRadius: "6px",
                      textAlign: "center",
                    }}
                  >
                    <FaClock
                      style={{
                        fontSize: "2.5rem",
                        color: "#adb5bd",
                        opacity: 0.5,
                      }}
                    />
                    <h4
                      style={{
                        fontSize: "1rem",
                        color: "#6c757d",
                        marginBottom: "8px",
                        fontWeight: "600",
                      }}
                    >
                      Nenhum horário cadastrado
                    </h4>
                    <p
                      style={{
                        fontSize: "0.85rem",
                        color: "#adb5bd",
                        margin: 0,
                        lineHeight: "1.4",
                      }}
                    >
                      Clique no botão "ADICIONAR HORÁRIO" para cadastrar
                    </p>
                  </div>
                )}
              </div>

              {/* Resumo */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: "5px",
                  borderTop: "1px solid #e8e8e8",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "0.85rem",
                    color: "#7f8c8d",
                  }}
                >
                  <FaListAlt style={{ fontSize: "0.9rem" }} />
                  <span>
                    {(horariosEditando[diaSemanaEditando] || []).length}{" "}
                    horário(s) para {getNomeDiaSemana(diaSemanaEditando)}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  {(horariosEditando[diaSemanaEditando] || []).length > 0 && (
                    <div
                      style={{
                        fontSize: "0.75rem",
                        color: "#28a745",
                        backgroundColor: "#e8f5e9",
                        padding: "3px 10px",
                        borderRadius: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {(horariosEditando[diaSemanaEditando] || []).length}{" "}
                      horários
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botão Fechar */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
            flexWrap: "wrap",
          }}
        >
          <Button
            label="CANCELAR"
            icon="pi pi-times"
            onClick={() => {
              resetarCampos();
              setVisibleHorariosProfissional(false);
            }}
            className="p-button-outlined p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "6px 20px",
              minWidth: "100px",
              borderColor: "#dee2e6",
              color: "#495057",
              fontWeight: "500",
              fontSize: "0.875rem",
            }}
            disabled={loading}
          />
          <Button
            label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
            icon="pi pi-check"
            onClick={handleSalvarHorarios}
            className="p-button-success p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "150px",
              fontWeight: "500",
              fontSize: "0.875rem",
            }}
            loading={loading}
          />
        </div>
      </Dialog>

      {/* Dialog Serviços do Profissional */}
      <Dialog
        visible={visibleServicosProfissional}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => !loading && setVisibleServicosProfissional(false)}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaList style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  SERVIÇOS DO
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PROFISSIONAL
                </div>
              </div>
            </div>
          </div>
        }
      >
        {/* Formulário em Cards */}
        <div style={{ padding: "20px 0" }}>
          {/* Card Principal - Controle de Serviços */}
          <div
            style={{
              display: "grid",
              backgroundColor: "#fafafa",
              border: "1px solid #e8e8e8",
              padding: "15px",
              borderRadius: "6px",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
              }}
            >
              {/* Cabeçalho do Card */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingBottom: "10px",
                  borderBottom: "2px solid #3498DB",
                }}
              >
                {/* Título do Card */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <FaList style={{ color: "#3498DB", fontSize: "1rem" }} />
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#2c3e50",
                      fontSize: "1rem",
                      letterSpacing: "0.3px",
                    }}
                  >
                    Controle de Serviços
                  </span>
                </div>
              </div>

              {/* Seletor de Serviços */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  padding: "10px",
                  backgroundColor: "#fff",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                }}
              >
                <MultiSelect
                  value={servicosSelecionados}
                  options={servicosDisponiveis.filter(
                    (s) =>
                      !servicosSelecionados.some(
                        (selected) => selected.id === s.id,
                      ),
                  )}
                  optionLabel="descricao"
                  placeholder="Selecione os serviços..."
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    width: "100%",
                    height: '35px',
                    fontFamily: "'Rajdhani', sans-serif",
                    border: "1px solid #dee2e6",
                    borderRadius: "4px",
                  }}
                  panelStyle={{
                    fontFamily: "'Rajdhani', sans-serif",
                  }}
                  onChange={(e) => handleAdicionarServico(e.value)}
                  itemTemplate={(s) => (
                    <div
                      style={{
                        fontFamily: "'Rajdhani', sans-serif",
                        padding: "8px 12px",
                        fontSize: "0.9rem",
                      }}
                    >
                      <div style={{ fontWeight: "600", color: "#2c3e50" }}>
                        {s.descricao}
                      </div>
                      <div
                        style={{
                          fontSize: "0.8rem",
                          color: "#7f8c8d",
                          display: "flex",
                          gap: "10px",
                          marginTop: "2px",
                        }}
                      >
                        <span>
                          <FaClock
                            style={{ fontSize: "0.7rem", marginRight: "3px" }}
                          />
                          {s.duracao} min
                        </span>
                        <span>
                          <FaDollarSign
                            style={{ fontSize: "0.7rem", marginRight: "3px" }}
                          />
                          R$ {parseFloat(s.valor).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  )}
                  emptyMessage="Nenhum serviço disponível"
                />
              </div>

              {/* Área dos Horários */}
              <div style={{ marginBottom: "10px" }}>
                {servicosSelecionados.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {servicosSelecionados.map((servico, index) => (
                      <div
                        key={servico.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          padding: "10px",
                          backgroundColor: "white",
                          borderRadius: "6px",
                          border: "1px solid #e8e8e8",
                          transition: "all 0.2s ease",
                        }}
                      >
                        {/* Número de Ordem */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "24px",
                            height: "24px",
                            backgroundColor: "#3498DB",
                            color: "white",
                            borderRadius: "50%",
                            fontSize: "0.8rem",
                            fontWeight: "600",
                            flexShrink: 0,
                          }}
                        >
                          {index + 1}
                        </div>

                        {/* Informações do Serviço */}
                        <div
                          style={{
                            flex: 1,
                            padding: "4px 12px",
                            backgroundColor: "white",
                            border: "1px solid #dee2e6",
                            borderRadius: "4px",
                            outline: "none",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            color: "#2c3e50",
                            fontFamily: "'Rajdhani', sans-serif",
                          }}
                        >
                          <div style={{ fontWeight: "600" }}>
                            {servico.descricao}
                          </div>
                          <div
                            style={{
                              fontSize: "0.8rem",
                              color: "#7f8c8d",
                              display: "flex",
                              gap: "5px",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <FaClock
                                style={{
                                  fontSize: "0.7rem",
                                  marginRight: "3px",
                                }}
                              />
                              {servico.duracao} min
                            </span>
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <FaDollarSign
                                style={{
                                  fontSize: "0.7rem",
                                  marginRight: "3px",
                                }}
                              />
                              R$ {parseFloat(servico.valor).toFixed(2)}
                            </span>
                          </div>
                        </div>

                        {/* Botão Remover */}
                        <Button
                          icon="pi pi-trash"
                          onClick={() => handleRemoverServico(servico.id)}
                          className="p-button-danger p-button-sm"
                          style={{
                            width: "34px",
                            height: "34px",
                            flexShrink: 0,
                          }}
                          tooltip="Remover"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "5px",
                      backgroundColor: "#fafafa",
                      border: "2px dashed #dee2e6",
                      borderRadius: "6px",
                      textAlign: "center",
                    }}
                  >
                    <FaList
                      style={{
                        fontSize: "2.5rem",
                        color: "#adb5bd",
                        opacity: 0.5,
                      }}
                    />
                    <h4
                      style={{
                        fontSize: "1rem",
                        color: "#6c757d",
                        marginBottom: "8px",
                        fontWeight: "600",
                      }}
                    >
                      Nenhum serviço cadastrado
                    </h4>
                    <p
                      style={{
                        fontSize: "0.85rem",
                        color: "#adb5bd",
                        margin: 0,
                        lineHeight: "1.4",
                      }}
                    >
                      Selecione serviços na lista para adicionar
                    </p>
                  </div>
                )}
              </div>

              {/* Resumo */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: "5px",
                  borderTop: "1px solid #e8e8e8",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "0.85rem",
                    color: "#7f8c8d",
                  }}
                >
                  <FaClipboardList style={{ fontSize: "0.9rem" }} />
                  <span>
                    {servicosSelecionados.length} serviço(s) selecionado(s)
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  {servicosSelecionados.length > 0 && (
                    <div
                      style={{
                        fontSize: "0.75rem",
                        color: "#28a745",
                        backgroundColor: "#e8f5e9",
                        padding: "3px 10px",
                        borderRadius: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {servicosSelecionados.length} serviços
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botão Fechar */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
            flexWrap: "wrap",
          }}
        >
          <Button
            label="CANCELAR"
            icon="pi pi-times"
            onClick={() => {
              resetarCampos();
              setVisibleServicosProfissional(false);
            }}
            className="p-button-outlined p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "6px 20px",
              minWidth: "100px",
              borderColor: "#dee2e6",
              color: "#495057",
              fontWeight: "500",
              fontSize: "0.875rem",
            }}
            disabled={loading}
          />
          <Button
            label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
            icon="pi pi-check"
            onClick={handleSalvarServicos}
            className="p-button-success p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "150px",
              fontWeight: "500",
              fontSize: "0.875rem",
            }}
            disabled={
              loading ||
              (servicosParaAdicionar.length === 0 &&
                servicosParaRemover.length === 0)
            }
            loading={loading}
          />
        </div>
      </Dialog>

      {/* Barra superior vermelha */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "40px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "fixed",
          zIndex: 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* lado esquerdo */}
        <div></div>

        {/* Centro */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon="pi pi-refresh"
            className="icon-button-titulo"
            onClick={() => {
              fetchEmpresas();
              fetchProfissionais();
              fetchServicos();
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={visualizacaoResumida ? "pi pi-eye" : "pi pi-eye-slash"}
            className="icon-button-titulo"
            onClick={() => {
              setVisualizacaoResumida(!visualizacaoResumida);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={
              mostrarFiltroProfissional ? "pi pi-filter-slash" : "pi pi-filter"
            }
            className="icon-button-titulo"
            onClick={() => {
              setMostrarFiltroProfissional(!mostrarFiltroProfissional);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon="pi pi-plus"
            className="icon-button-titulo"
            onClick={() => {
              if (
                user.tipo === "administrator" ||
                user.modulos?.Profissionais?.editar
              ) {
                setVisibleNovoProfissional(true);
                resetarCampos();
              }
            }}
            disabled={
              !(
                user.tipo === "administrator" ||
                user.modulos?.Profissionais?.editar
              )
            }
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              opacity:
                user.tipo === "administrator" ||
                user.modulos?.Profissionais?.editar
                  ? 1
                  : 0.4,
              cursor:
                user.tipo === "administrator" ||
                user.modulos?.Profissionais?.editar
                  ? "pointer"
                  : "not-allowed",
            }}
            outlined
          />
        </div>

        {/* lado direito */}
        <div></div>
      </div>

      {/* Conteúdo abaixo da barra */}
      <div style={{ flex: 1, padding: "50px 10px" }}>
        {/* MOSTRAR RESERVAS DO DIA SELECIONADO - SEMPRE VISÍVEL */}
        <div style={{ borderRadius: "8px", padding: "0 15px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #E2E8F0",
            }}
          >
            <div style={{ marginTop: "7px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  gap: "5px",
                }}
              >
                <FaUserMd style={{ color: "#B83732", fontSize: "1.2rem" }} />
                <h3 style={{ margin: 0, color: "#424242" }}>PROFISSIONAIS</h3>

                {/* Bolinha com quantidade */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "25px",
                    height: "25px",
                    background:
                      "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                    borderRadius: "50px",
                    padding: "0 8px",
                    margin: "0 8px",
                    boxShadow: "0 2px 4px rgba(184, 55, 50, 0.2)",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                      lineHeight: 1,
                    }}
                  >
                    {profissionais.length}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <IconField iconPosition="left">
                <InputIcon className="pi pi-search"> </InputIcon>
                <InputText
                  className="p-inputtext-sm"
                  placeholder="Pesquisar por Nome"
                  value={filtroNome}
                  onChange={(e) => setFiltroNome(e.target.value)}
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    width: "100%",
                    height: "30px",
                    fontFamily: "'Rajdhani', sans-serif",
                  }}
                />
              </IconField>
            </div>
          </div>

          {/* InputSwitch */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginBottom: "30px",
            }}
          ></div>

          {/* Filtros*/}
          {mostrarFiltroProfissional && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  padding: "10px 8px",
                  border: "1px solid #dee2e6",
                  backgroundColor: "#fff",
                  width: "95%",
                  maxWidth: "920px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                {/* 1ª Linha - Nome e CPF */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "10px",
                  }}
                >
                  {/* Card Nome */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498DB",
                        }}
                      >
                        <FaUserMd
                          style={{ color: "#3498DB", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Nome{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Nome do paciente"
                        value={filtroNome}
                        onChange={(e) => setFiltroNome(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card CPF */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #E67E22",
                        }}
                      >
                        <FaIdCard
                          style={{ color: "#E67E22", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          CPF{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="CPF do paciente"
                        value={filtroCpf}
                        onChange={(e) => setFiltroCpf(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Telefone */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #2980b9",
                        }}
                      >
                        <FaPhone
                          style={{ color: "#2980b9", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Telefone
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Telefone do paciente"
                        value={filtroTelefone}
                        onChange={(e) => setFiltroTelefone(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Email */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #d35400",
                        }}
                      >
                        <FaEnvelope
                          style={{ color: "#d35400", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Email
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Email do paciente"
                        value={filtroEmail}
                        onChange={(e) => setFiltroEmail(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Grids */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 8px",
            }}
          >
            {profissionaisFiltrados.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "2px dashed #e8e8e8",
                }}
              >
                <FaUserMd
                  style={{
                    fontSize: "3rem",
                    color: "#B83732",
                    marginBottom: "15px",
                    opacity: 0.5,
                  }}
                />
                <h3
                  style={{
                    color: "#2c3e50",
                    margin: "0 0 10px 0",
                    fontSize: "1.2rem",
                    fontWeight: "600",
                  }}
                >
                  Nenhum profissional encontrado
                </h3>
              </div>
            ) : !visualizacaoResumida ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {profissionaisFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px 14px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* Bloco esquerdo - Profissional */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          minWidth: "260px",
                          flex: "1 1 260px",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                            borderRadius: "10px",
                            padding: "10px",
                            display: "inline-flex",
                          }}
                        >
                          <FaUserMd
                            style={{ fontSize: "1.5rem", color: "#fff" }}
                          />
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: 0,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.nome}
                          </h3>

                          {/* Info Tags */}
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "5px",
                              alignItems: "center",
                              color: "#64748b",
                              fontSize: "0.9rem",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                marginRight: "6px",
                              }}
                            >
                              <FaIdCard
                                style={{ fontSize: "0.7rem", color: "#64748b" }}
                              />
                              <span>{item.cpf}</span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                marginRight: "6px",
                              }}
                            >
                              <FaPhone
                                style={{ fontSize: "0.7rem", color: "#2980b9" }}
                              />
                              <span>{item.telefone}</span>
                            </div>

                            {/* Empresas */}
                            {item.empresas && item.empresas.length > 0 ? (
                              item.empresas.map((empresa) => (
                                <div
                                  key={empresa.id}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    marginBottom: "3px",
                                  }}
                                >
                                  <FaBuilding
                                    style={{
                                      color: "#2980b9",
                                      fontSize: "0.75rem",
                                    }}
                                  />
                                  <span>{empresa.nome}</span>
                                </div>
                              ))
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <FaBuilding
                                  style={{
                                    color: "#95a5a6",
                                    fontSize: "0.75rem",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.85rem",
                                    color: "#95a5a6",
                                  }}
                                >
                                  Nenhuma empresa vinculada
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Status + Ações */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          gap: "8px",
                          flex: "1 1 320px",
                          marginLeft: "auto",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "2px 6px",
                            borderRadius: "12px",
                            fontSize: "0.75rem",
                            fontWeight: "500",
                            color: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                          }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              borderRadius: "50%",
                              backgroundColor:
                                item.ativo === "1" ? "#27ae60" : "#e74c3c",
                            }}
                          />
                        </div>

                        {/* Botões de ação */}
                        <Button
                          icon="pi pi-file-edit"
                          onClick={() => {
                            if (
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                            ) {
                              setProfissionalEditandoId(item.id);

                              // Preenche os campos do formulário
                              setNome(item.nome || "");
                              setEmail(item.email || "");
                              setTelefone(item.telefone || "");
                              setCpf(item.cpf || "");
                              setRg(item.rg || "");
                              setCro(item.cro || "");
                              setEspecialidade(item.especialidade || "");
                              setLogradouro(item.logradouro || "");
                              setNumero(item.numero || "");
                              setBairro(item.bairro || "");
                              setCidade(item.cidade || "");
                              setEstado(item.estado || "");
                              setCep(item.cep || "");
                              setAtivo(item.ativo === "1");

                              // Preenche empresas selecionadas
                              if (
                                item.empresas &&
                                Array.isArray(item.empresas)
                              ) {
                                const empresasIds = item.empresas.map(
                                  (emp) => emp.id,
                                );
                                setEmpresasSelecionadas(empresasIds);
                              } else {
                                setEmpresasSelecionadas([]);
                              }

                              setVisibleEditarProfissional(true);
                            }
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Editar"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-calendar"
                          onClick={async () => {
                            if (
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                            ) {
                              setProfissionalEditandoId(item.id);
                              await buscarDatasProfissional(item.id);
                              setVisibleDatasProfissional(true);
                            }
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Datas"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-clock"
                          onClick={async () => {
                            if (
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                            ) {
                              setProfissionalEditandoId(item.id);
                              await buscarHorariosProfissional(item.id);
                              setVisibleHorariosProfissional(true);
                            }
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Horários"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-list"
                          onClick={async () => {
                            if (
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                            ) {
                              setProfissionalEditandoId(item.id);
                              await buscarServicosProfissional(item.id);
                              setVisibleServicosProfissional(true);
                            }
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Profissionais?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Serviços"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  gap: "15px",
                  alignItems: "stretch",
                }}
              >
                {profissionaisFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      {/* Informações do Profissional */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          marginBottom: "5px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #e8e8e8",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                            borderRadius: "10px",
                            padding: "10px",
                            display: "inline-flex",
                          }}
                        >
                          <FaUserMd
                            style={{ fontSize: "1.5rem", color: "#fff" }}
                          />
                        </div>

                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: "0",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.nome}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#64748b",
                              fontSize: "0.85rem",
                            }}
                          >
                            <FaIdCard
                              style={{ fontSize: "0.7rem", color: "#64748b" }}
                            />
                            <span>
                              {item.especialidade ||
                                "Especialidade não informada"}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Detalhes do Profissional */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr",
                          gap: "6px",
                          marginBottom: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaPhone
                              style={{
                                color: "#2980b9",
                                fontSize: "0.75rem",
                              }}
                            />
                            <span
                              style={{
                                fontSize: "0.8rem",
                                color: "#2c3e50",
                                fontWeight: "500",
                              }}
                            >
                              {item.telefone}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Empresas */}
                      <div
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e8e8e8",
                          padding: "6px",
                          borderRadius: "6px",
                          marginBottom: "6px",
                        }}
                      >
                        {item.empresas && item.empresas.length > 0 ? (
                          item.empresas.map((empresa) => (
                            <div
                              key={empresa.id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                marginBottom: "3px",
                              }}
                            >
                              <FaBuilding
                                style={{
                                  color: "#2980b9",
                                  fontSize: "0.75rem",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.85rem",
                                  color: "#2c3e50",
                                  fontWeight: "500",
                                }}
                              >
                                {empresa.nome}
                              </span>
                            </div>
                          ))
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaBuilding
                              style={{
                                color: "#95a5a6",
                                fontSize: "0.75rem",
                              }}
                            />
                            <span
                              style={{
                                fontSize: "0.85rem",
                                color: "#95a5a6",
                              }}
                            >
                              Nenhuma empresa vinculada
                            </span>
                          </div>
                        )}
                      </div>

                      {/* Ações Secundárias */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingTop: "5px",
                          gap: "5px",
                          marginTop: "auto",
                          borderTop: "1px solid #e8e8e8",
                        }}
                      >
                        {/* Ativo */}
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              fontFamily: "'Rajdhani', sans-serif",
                              gap: "6px",
                              padding: "2px 6px",
                              borderRadius: "12px",
                              fontSize: "0.75rem",
                              fontWeight: "500",
                              color: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                            }}
                          >
                            <div
                              style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                backgroundColor:
                                  item.ativo === "1" ? "#27ae60" : "#e74c3c",
                              }}
                            />
                          </div>
                        </div>

                        {/* Botões de ação */}
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <Button
                            icon="pi pi-file-edit"
                            onClick={() => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                              ) {
                                setProfissionalEditandoId(item.id);

                                // Preenche os campos do formulário
                                setNome(item.nome || "");
                                setEmail(item.email || "");
                                setTelefone(item.telefone || "");
                                setCpf(item.cpf || "");
                                setRg(item.rg || "");
                                setCro(item.cro || "");
                                setEspecialidade(item.especialidade || "");
                                setLogradouro(item.logradouro || "");
                                setNumero(item.numero || "");
                                setBairro(item.bairro || "");
                                setCidade(item.cidade || "");
                                setEstado(item.estado || "");
                                setCep(item.cep || "");
                                setAtivo(item.ativo === "1");

                                // Preenche empresas selecionadas
                                if (
                                  item.empresas &&
                                  Array.isArray(item.empresas)
                                ) {
                                  const empresasIds = item.empresas.map(
                                    (emp) => emp.id,
                                  );
                                  setEmpresasSelecionadas(empresasIds);
                                } else {
                                  setEmpresasSelecionadas([]);
                                }

                                setVisibleEditarProfissional(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Editar"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-calendar"
                            onClick={async () => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                              ) {
                                setProfissionalEditandoId(item.id);
                                await buscarDatasProfissional(item.id);
                                setVisibleDatasProfissional(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Datas"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-clock"
                            onClick={async () => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                              ) {
                                setProfissionalEditandoId(item.id);
                                await buscarHorariosProfissional(item.id);
                                setVisibleHorariosProfissional(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Horários"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-list"
                            onClick={async () => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                              ) {
                                setProfissionalEditandoId(item.id);
                                await buscarServicosProfissional(item.id);
                                setVisibleServicosProfissional(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Profissionais?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Serviços"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Loading Spinner */}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="8"
          />
        </div>
      )}
    </div>
  );
};

export default Profissionais;
